/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UserPreferences interface.
 */
export function instanceOfUserPreferences(_value) {
    return true;
}
export function UserPreferencesFromJSON(json) {
    return UserPreferencesFromJSONTyped(json, false);
}
export function UserPreferencesFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'autoStopDuration': json['autoStopDuration'] == null ? undefined : json['autoStopDuration'],
        'customInstructions': json['customInstructions'] == null ? undefined : json['customInstructions'],
        'customText': json['customText'] == null ? undefined : json['customText'],
        'language': json['language'] == null ? undefined : json['language'],
        'tone': json['tone'] == null ? undefined : json['tone'],
    };
}
export function UserPreferencesToJSON(json) {
    return UserPreferencesToJSONTyped(json, false);
}
export function UserPreferencesToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'autoStopDuration': value['autoStopDuration'],
        'customInstructions': value['customInstructions'],
        'customText': value['customText'],
        'language': value['language'],
        'tone': value['tone'],
    };
}
